import { Controller } from "@hotwired/stimulus"

/**
 * Character Counter Controller - Displays remaining characters for textarea/input
 *
 * Usage:
 * <div data-controller="character-counter" data-character-counter-max-value="500">
 *   <textarea data-character-counter-target="field" data-action="input->character-counter#update"></textarea>
 *   <p data-character-counter-target="counter">0 / 500</p>
 * </div>
 */
export default class extends Controller {
  static targets = ["field", "counter"]
  static values = {
    max: Number
  }

  connect() {
    // Initialize count on connect
    this.updateCount()
  }

  // Method called by Stimulus action
  update() {
    this.updateCount()
  }

  updateCount() {
    if (!this.hasFieldTarget) return

    const current = this.fieldTarget.value.length
    const max = this.maxValue

    if (this.hasCounterTarget) {
      this.counterTarget.textContent = `${current} / ${max}`

      // Change color when approaching limit
      if (current > max * 0.9) {
        this.counterTarget.classList.add("text-orange-500")
        this.counterTarget.classList.remove("text-charcoal-500", "text-charcoal-500", "text-charcoal-500")
      } else {
        this.counterTarget.classList.remove("text-orange-500")
        this.counterTarget.classList.add("text-charcoal-500")
      }
    }
  }
}
